import { useState, useEffect, useRef } from "react";
import { MdOutlineQueue } from "react-icons/md";

import { toast } from "react-toastify";
import EquipmentGroupActions from "../../Actions/EquipmentGroupActions";
import EquipmentGroupContants from "../../Constants/EquipmentGroupConstants";
import equipmentGroupStore from "../../Stores/EquipmentGroupStore";
import { MdEdit, MdDelete } from "react-icons/md";
import { RiFileCopyLine } from "react-icons/ri";
import usermanagementStore from "../../Stores/UsermanagementStore";
import UsermanagementConstants from "../../Constants/UsermanagementConstants";
import UserManagementActions from "../../Actions/UserManagementActions";
import ConfirmationPopUp from "../MessageBox/ConfirmationPopUp";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../Context/LanguageContext";
import { Button } from "@mui/material";
import { MdOutlineAddBox } from "react-icons/md";
import commonUtils from "../../helpers/commonUtils";
import { useSelectedConfigActionContext } from "../../Context/GlobalContext";
import CopyEquipmentGroup from "./CopyEquipmentGroupPopUp";
import NewEquipmentGroup from "../NewEqupmentGroup/NewEquipmentGroup";
import { customizeFilter } from "../FilterOptions/CustomizeFilter";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import CustomDataGrid from "../ReusableComponent/DataGrid/CustomizeDataGrid";
import ImportComponent from "../ReusableComponent/ImportComponent/importComponent";
import ImportAction from "../../Actions/ImportAction";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import Pruef_PlanActions from "../../Actions/Pruef_PlanActions";
const EquipmentGroup = () => {
  const [equipmentGroupList, setEquipmentGroupList] = useState(null);
  const [resEquipmentGroupList, setResEquipmentGroupList] = useState([]);
  const [plantList, setPlantList] = useState([]);
  const [plantId, setPlantId] = useState(0);

  const [functionsList, setFunctionsList] = useState([]);
  const [menuList, setMenuList] = useState([]);
  const [egDetails, setEgDetails] = useState("");
  const [equGrpDetails, setEquGrpDetails] = useState("");
  const [equDetailsForCopyEquipmentGroup, setEquDetailsForCopyEquipmentGroup] =
    useState("");
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const prevPlantId = useRef("");
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const updateSelectedConfig = useSelectedConfigActionContext();
  const [operations, setOperations] = useState([]);
  const columns = [
    { field: "werk", headerName: localization.plant, hideable: false, flex: 1 },
    {
      field: "actions",
      type: "actions",
      width: 45,
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
    },
    { field: "bezeichnung", headerName: localization.designation, flex: 1 },
    { field: "abkuerzung", headerName: localization.shortcut, flex: 1 },
    { field: "location", headerName: localization.location, flex: 1 },
    {
      field: "pruefKriterium",
      headerName: localization.testCriterion,
      flex: 1,
    },
    {
      field: "hasChildren",
      headerName: localization.hasChildren,
      flex: 1,
      valueGetter: (params) =>
        params.row.hasChildren ? localization.yes : localization.no,
    },
    {
      field: "inventarNrLaenge",
      headerName: localization.inventoryLength,
      flex: 1,
    },
  ];
  const importIntial = {
    isOpen: false,
    headerTitle: localization.importEqGrp,
    subHeaderTitle: localization.importEqGrpTitle,
    handleClose: handleCloseImport,
    handleImport: handleImport,
    handleDownloadTemplate: handleDownloadTemplate,
  };
  const [openImport, setOpenImport] = useState(importIntial);
  const getPlantEquipmentGroups = (plantId) => {
    if (plantId != 0) {
      EquipmentGroupActions.getPlantEquipmentGroups(plantId);
      setGlobalSpinner(true);
    }
  };

  const getPlants = () => {
    UserManagementActions.getAdminOrPlantAdminPlants();
  };

  const getFonctionsByEquGroupId = (equGrpId) => {
    EquipmentGroupActions.GetAnlagegruppeFonctions(equGrpId);
  };

  const reloadEquipmentGroupList = () => {
    setPlantId(prevPlantId.current);
    getPlantEquipmentGroups(prevPlantId.current);
  };

  useEffect(() => {
    getPlants();
  }, []);

  useEffect(() => {
    prevPlantId.current = plantId;
    getPlantEquipmentGroups(plantId);
    function getPlantEqipmentGroupSuccess() {
      var res = equipmentGroupStore.getPlantEquipmentGroupList();
      if (res.length > 0) {
        setEquipmentGroupList(res);

        setResEquipmentGroupList(res);
      } else {
        setResEquipmentGroupList([]);
        setEquipmentGroupList([]);
      }
      updateSelectedConfig("Equipment Group");
      setGlobalSpinner(false);
    }

    function getPlantEqipmentGroupFailure() {
      setGlobalSpinner(false);
      updateSelectedConfig("Equipment Group");
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_PLANT_EQUIPMENT_GROUP_SUCCESS,
      getPlantEqipmentGroupSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_PLANT_EQUIPMENT_GROUP_FAILURE,
      getPlantEqipmentGroupFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_PLANT_EQUIPMENT_GROUP_SUCCESS,
        getPlantEqipmentGroupSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_PLANT_EQUIPMENT_GROUP_FAILURE,
        getPlantEqipmentGroupFailure,
      );
    };
  }, [plantId]);

  useEffect(() => {
    function getPlantSuccess() {
      var res = usermanagementStore.getAdminOrPlantAdminPlantsRes();

      if (res.length > 0) {
        setPlantList(res);
        setPlantId(res[0].id);
      } else {
        setPlantList([]);
      }
    }

    function getPlantFailure() {}

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_ADMIN_OR_PLANT_ADMIN_PLANT_SUCCESS,
      getPlantSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_ADMIN_OR_PLANT_ADMIN_PLANT_FAILURE,
      getPlantFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_ADMIN_OR_PLANT_ADMIN_PLANT_SUCCESS,
        getPlantSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_ADMIN_OR_PLANT_ADMIN_PLANT_FAILURE,
        getPlantFailure,
      );
    };
  }, []);

  useEffect(() => {
    function deleteEquipmentGroupSuccess() {
      var res = equipmentGroupStore.getDeleteEquipmentGroupResult();
      setEquipmentGroupList(null);
      if (res.length === 0) {
        toast.success(localization.equipmentGroupDeletedSuccessfully);
      } else {
        res.forEach((item) => toast.error(item));
      }
      setPlantId(prevPlantId.current);
      getPlantEquipmentGroups(prevPlantId.current);

      setGlobalSpinner(false);
    }

    function deleteEquipmentGroupFailure() {
      var res = equipmentGroupStore.getDeleteEquipmentGroupResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.DELETE_EQUIPMENT_GROUP_SUCCESS,
      deleteEquipmentGroupSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.DELETE_EQUIPMENT_GROUP_FAILURE,
      deleteEquipmentGroupFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.DELETE_EQUIPMENT_GROUP_SUCCESS,
        deleteEquipmentGroupSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.DELETE_EQUIPMENT_GROUP_FAILURE,
        deleteEquipmentGroupFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getFonctionsByEupGrpSuccess() {
      const res = equipmentGroupStore.getFunction();

      if (res.length > 0) {
        setFunctionsList(res);
      } else {
        setFunctionsList([]);
      }
    }

    function getFonctionsByEupGrpFailure() {
      const res = equipmentGroupStore.getFunction();

      setFunctionsList([]);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_FUNCTION_SUCCESS,
      getFonctionsByEupGrpSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_FUNCTION_FAILURE,
      getFonctionsByEupGrpFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_FUNCTION_SUCCESS,
        getFonctionsByEupGrpSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_FUNCTION_FAILURE,
        getFonctionsByEupGrpFailure,
      );
    };
  }, []);

  useEffect(() => {
    function copyEquipmentGroupSuccess() {
      var res = equipmentGroupStore.geCopyEquipmentGroupResult();

      if (res) {
        commonUtils.hideModalPopUp("copyEquipmentGroupClose");
        toast.success(localization.equipmentGroupCopiedSuccessfully);
        setPlantId(prevPlantId.current);
        getPlantEquipmentGroups(prevPlantId.current);
      }
      setGlobalSpinner(false);
    }

    function copyEquipmentGroupFailure() {
      var res = equipmentGroupStore.geCopyEquipmentGroupResult();

      setGlobalSpinner(false);
      toast.error(res);
    }
    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.COPY_EQUIPMENT_GROUP_SUCCESS,
      copyEquipmentGroupSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.COPY_EQUIPMENT_GROUP_FAILURE,
      copyEquipmentGroupFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.COPY_EQUIPMENT_GROUP_SUCCESS,
        copyEquipmentGroupSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.COPY_EQUIPMENT_GROUP_FAILURE,
        copyEquipmentGroupFailure,
      );
    };
  }, []);

  const handleEdit = (row) => {
    setGlobalSpinner(true);
    commonUtils.setIsEdit(true);
    setEgDetails(row);

    EquipmentGroupActions.getSummaryEqGrp(row.id);
  };
  function RenderEditButton() {
    return (
      <>
        <Button
          id="editEquipmentGroupTest"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<MdEdit />}
          data-toggle="modal"
          data-target="#newEquipmentGroup"
        >
          {localization.toolTipEdit}
        </Button>
      </>
    );
  }
  const handleDelete = (row) => {
    const _idList = [];
    if (Array.isArray(row)) {
      row.forEach((b) => _idList.push(b.id));
    } else {
      _idList.push(row.id);
    }
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.delEqGrpAlert);
    setCallbackData({
      equipmentGroupId: _idList,
    });
    setEventType("DELETE_EQUIPMENT_GROUP");
  };

  function handleActionButtons(action, rowData) {
    switch (action) {
      case "DELETE_TEMPLATE":
        setConfirmationPopUpOpen(true);
        setConfirmationPopUpMsg(localization.deleteConfirmation);
        setCallbackData(rowData);
        setEventType("DELETE_TEMPLATE");
        break;
    }
  }

  function RenderDeleteButtonForRole(props) {
    const id = props.id;
    return (
      <Button
        id="deleteEquipmentGroupTest"
        className="mr-4 cursorPoint svgIcon"
        variant="outlined"
        startIcon={<MdDelete />}
      >
        {localization.delete}
      </Button>
    );
  }
  const handleAdd = (row) => {
    setEquGrpDetails(row);
  };
  function RenderAddEquipmentButton() {
    return (
      <Button
        id="addEquipmentToEquGroupTest"
        className="mr-4 cursorPoint svgIcon"
        variant="outlined"
        startIcon={<MdOutlineAddBox />}
        data-toggle="modal"
        data-target="#newEquipmentGroup"
      >
        {localization.add}
      </Button>
    );
  }

  const handleCopy = (row) => {
    setEquDetailsForCopyEquipmentGroup(row);
  };

  function RenderCopyEquipmentGroupButton(props) {
    const currentRow = props.currentRow;
    return (
      <>
        <Button
          id="copyEquipmentGroupTest"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<RiFileCopyLine />}
          data-toggle="modal"
          data-target="#copyEquipmentGroup"
        >
          {localization.copyTitle}
        </Button>
      </>
    );
  }

  function handleImportClick() {
    setOpenImport((prev) => ({
      ...prev,
      isOpen: true,
    }));
  }

  function RenderImportButton() {
    return (
      <Button
        id="import"
        className="svgIcon cursorPoint"
        variant="outlined"
        startIcon={<UploadFileOutlinedIcon />}
        onClick={handleImportClick}
      >
        {localization.import}
      </Button>
    );
  }
  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DELETE_EQUIPMENT_GROUP":
          setGlobalSpinner(true);
          EquipmentGroupActions.deleteEquipmentGroup(
            data.equipmentGroupId,
            plantId,
          );
          closePopUpCallback();
          break;
        case "DELETE_TEMPLATE":
          setGlobalSpinner(true);
          Pruef_PlanActions.deleteChecklistTemplate(data);
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };
  const closeCreatePopOver = () => {
    setEgDetails("");
  };

  useEffect(() => {
    const plantData = plantList.find((plant) => plant.id === plantId);
    if (plantData && plantData.roleId && plantData.roleId === 3) {
      setOperations({
        RowOperationList: [
          {
            label: "Edit",
            component: <RenderEditButton />,
            onClick: handleEdit,
          },
          {
            label: "Delete",
            component: <RenderDeleteButtonForRole />,
            onClick: handleDelete,
          },
        ].filter(Boolean),
        GridToolBarAction: [],
        SelectedToolBar: [
          {
            label: "Delete",
            component: <RenderDeleteButtonForRole />,
            onClick: handleDelete,
          },
        ],
      });
    } else {
      setOperations({
        RowOperationList: [
          {
            label: "Edit",
            component: <RenderEditButton />,
            onClick: handleEdit,
          },
          {
            label: "Delete",
            component: <RenderDeleteButtonForRole />,
            onClick: handleDelete,
          },
          (commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin()) && {
            label: "Copy",
            component: <RenderCopyEquipmentGroupButton />,
            onClick: handleCopy,
          },
        ].filter(Boolean),
        GridToolBarAction: [
          (commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin()) && {
            label: "Add",
            component: <RenderAddEquipmentButton />,
            onClick: handleAdd,
          },
          (commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin()) && {
            label: "Import",
            component: <RenderImportButton />,
            onClick: handleImportClick,
          },
        ].filter(Boolean),
        SelectedToolBar: [
          {
            label: "Delete",
            component: <RenderDeleteButtonForRole />,
            onClick: handleDelete,
          },
        ],
      });
    }

    return () => {};
  }, [plantId]);

  function handleImport(seletedFile) {
    setGlobalSpinner(true);

    const obj = {
      ImportType: "EquipmentGroup",
      WerkId: prevPlantId.current,
      ImportFile: seletedFile,
    };
    ImportAction.uploadData(obj);
  }

  function handleCloseImport(_message) {
    if (_message === "success") {
      setPlantId(prevPlantId.current);
      getPlantEquipmentGroups(prevPlantId.current);
    }
    setOpenImport((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }

  function handleDownloadTemplate() {
    ImportAction.getTemplate({
      ImportType: "EquipmentGroup",
      UpdateTempalte: false,
      WerkId: prevPlantId.current,
    });
    setGlobalSpinner(true);
  }
  function getAction(params) {
    const plantData = plantList.find((plant) => plant.id === plantId);
    const _acionList = [];
    _acionList.push(
      <GridActionsCellItem
        label={localization.toolTipEdit}
        showInMenu
        onClick={() => handleEdit(params.row)}
        data-toggle="modal"
        data-target="#newEquipmentGroup"
      />,
    );
    _acionList.push(
      <GridActionsCellItem
        label={localization.delete}
        showInMenu
        onClick={() => handleDelete(params.row)}
      />,
    );
    if (plantData && plantData.roleId && plantData.roleId != 3) {
      if (
        commonUtils.isUserOrganisationAdmin() ||
        commonUtils.isUserWerkAdmin()
      ) {
        _acionList.push(
          <GridActionsCellItem
            label={localization.copyTitle}
            showInMenu
            onClick={() => handleCopy(params.row)}
            data-toggle="modal"
            data-target="#copyEquipmentGroup"
          />,
        );
      }
    }

    return _acionList;
  }
  return (
    <>
      <div className="w-100 h-100 equipmentGroupList" id="content">
        {equipmentGroupList && (
          <CustomDataGrid
            Title={
              localization.equSetting + " / " + localization.equipmentGroup
            }
            renderParentComponent={
              <div className="form-group d-flex  align-items-center">
                <label htmlFor="plantList" className="mr-3">
                  {localization.plant}
                </label>
                <select
                  className="form-control"
                  id="plantList"
                  name="plantList"
                  required
                  value={plantId}
                  onChange={(e) => {
                    setPlantId(e.target.value);
                  }}
                >
                  {plantList.map((row, index) => {
                    return (
                      <option key={index} value={row.id}>
                        {row.bezeichnung}
                      </option>
                    );
                  })}
                </select>
              </div>
            }
            columns={columns}
            rows={equipmentGroupList}
            operations={operations}
            onAdd={handleAdd}
            showExport={true}
            showColumns={true}
            showFilters={true}
            showDensity={true}
            visibleColumns={[
              "werk",
              "bezeichnung",
              "abkuerzung",
              "location",

              "inventarNrLaenge",
              "hastZeitRueckmeldung",
              "isInvnrEditierbar",
              "pruefKriterium",
            ]}
            showCheckBox={true}
            gridTableHeight={"dataGridSmall"}
            madeChanges={true}
          />
        )}
      </div>
      {openImport.isOpen && <ImportComponent data={openImport} />}
      <NewEquipmentGroup
        egDetails={egDetails}
        plantList={plantList}
        selectedPlantId={plantId}
        equMenuList={menuList}
        orgFunctionsList={functionsList}
        reloadEquipmentGroupList={reloadEquipmentGroupList}
        closeCreatePopOver={closeCreatePopOver}
        equGrpDetails={equGrpDetails}
        setEgDetails={setEgDetails}
        handleActionButtons={handleActionButtons}
      />
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />

      <CopyEquipmentGroup
        equGrpDetailsForCopy={equDetailsForCopyEquipmentGroup}
        plantList={plantList}
        plantId={plantId}
      />
    </>
  );
};

export default EquipmentGroup;
